/* eslint-disable indent */
import React from "react";
import styles from "../stylesER.module.scss";

const mesesAbrev = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];

const mostrarFecha = (fechaStr) => {
  if (!fechaStr) return "Ingresar fecha";
  const [, month, day] = fechaStr.split("-");
  return `${day}-${mesesAbrev[parseInt(month) - 1]}`;
};

export const HardwareIngresosModal = ({
  isOpen,
  detalleHardwareIngresos,
  selectedYear,
  currentYear,
  mesesCompletos,
  pais,
  moneda,
  localString,
  formatCurrency,
  getNombreNegocio,
  getFechaFacturaHardware,
  getDolarValue,
  getUFValue,
  convertirAMonedaLocal,
  costosGestionData,
  ingresosHardwareTotal,
  // Props mantenidos por compatibilidad (edición deshabilitada, solo lectura)
  editingFechaId: _editingFechaId,
  setEditingFechaId: _setEditingFechaId,
  editingFechaValue: _editingFechaValue,
  setEditingFechaValue: _setEditingFechaValue,
  onSaveFecha: _onSaveFecha,
  onClose,
}) => {
  if (!isOpen || !detalleHardwareIngresos) return null;

  const { monthIndex, negocios } = detalleHardwareIngresos;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div
        className={styles.modalContent}
        style={{ maxWidth: "1600px", width: "95%", margin: "10px auto" }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3>
          Detalle Ingresos Hardware - {mesesCompletos[monthIndex]} {selectedYear}
        </h3>
        <div style={{ overflowX: "auto" }}>
          <table className={styles.modalTable} style={{ minWidth: "1400px" }}>
            <colgroup>
              <col style={{ width: "5%" }} />
              <col style={{ width: "15%" }} />
              <col style={{ width: "8%" }} />
              <col style={{ width: "10%" }} />
              <col style={{ width: "12%" }} />
              <col style={{ width: "12%" }} />
              {pais === "Perú" && <col style={{ width: "10%" }} />}
              {pais === "Chile" && <col style={{ width: "10%" }} />}
              <col style={{ width: "12%" }} />
            </colgroup>
            <thead>
              <tr>
                <th>ID</th>
                <th>CLIENTE / EDIFICIO</th>
                <th>PANTALLAS</th>
                <th>MODALIDAD</th>
                <th>CUOTA / MONTO</th>
                <th>FECHA FACTURA</th>
                {pais === "Perú" && <th>VALOR DÓLAR</th>}
                {pais === "Chile" && <th>VALOR UF</th>}
                <th>TOTAL {moneda(pais).trim()}</th>
              </tr>
            </thead>
            <tbody>
              {negocios.map((n) => {
                const nombre = getNombreNegocio(n);
                const pantallas = Number(n.cantidad_pantallas) || 1;
                const monedaHw = (n.moneda_hardware || "UF").toUpperCase();
                const cuotasEnMes = n._cuotasEnMes || 1;
                const fechaUsada = n._facturaFecha || getFechaFacturaHardware(n, monthIndex);
                const registro = costosGestionData.find(
                  (c) =>
                    Number(c.negocio_id) === Number(n.id) &&
                    Number(c.mes) === monthIndex + 1 &&
                    Number(c.ano) === currentYear
                );
                const fechaFacturaGuardada = n._facturaFecha || registro?.fecha_factura?.split("T")[0] || null;

                const isUSD = monedaHw === "US$" || monedaHw === "USD";
                const valorReferencia = isUSD
                  ? getDolarValue(fechaUsada)
                  : pais === "Chile" && monedaHw === "UF"
                    ? getUFValue(fechaUsada)
                    : null;

                // CAPEX con desglose: monto del/los tramo(s) facturado(s) en este mes (_montoTramoMes,
                // propagado desde openHardwareIngresosModal) para reconciliar con la celda "B - Hardware"
                // (10.229). Sin desglose (fallback fecha_cierre) → monto_hardware entero, como antes.
                const montoOriginal =
                  n.modalidad === "OPEX"
                    ? Number(n.cuota_hardware_opex) * pantallas * cuotasEnMes
                    : n._montoTramoMes != null
                      ? Number(n._montoTramoMes)
                      : Number(n.monto_hardware) || 0;

                const totalLocal = convertirAMonedaLocal(
                  montoOriginal,
                  monedaHw,
                  pais,
                  n.id,
                  monthIndex + 1,
                  selectedYear,
                  fechaUsada
                );

                return (
                  <tr key={n.id}>
                    <td style={{ textAlign: "center", fontWeight: "600" }}>{n.id}</td>
                    <td>{nombre}</td>
                    <td style={{ textAlign: "center" }}>{pantallas}</td>
                    <td>{n.modalidad}</td>
                    <td style={{ textAlign: "right" }}>
                      {montoOriginal.toLocaleString(localString(pais), {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}{" "}
                      {monedaHw}
                    </td>
                    <td style={{ padding: "8px", textAlign: "center" }}>
                      <span
                        style={{
                          backgroundColor: fechaFacturaGuardada ? "#e8f5e8" : "#ffebee",
                          color: fechaFacturaGuardada ? "#1b5e20" : "#c62828",
                          padding: "8px 16px",
                          borderRadius: "8px",
                          fontWeight: "600",
                          fontSize: "13px",
                          display: "inline-block",
                        }}
                      >
                        {fechaFacturaGuardada ? mostrarFecha(fechaFacturaGuardada) : "Sin fecha"}
                      </span>
                    </td>
                    {pais === "Perú" && (
                      <td style={{ textAlign: "center" }}>
                        {isUSD
                          ? valorReferencia.toLocaleString("es-PE", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : "-"}
                      </td>
                    )}
                    {pais === "Chile" && (
                      <td style={{ textAlign: "center" }}>
                        {valorReferencia
                          ? valorReferencia.toLocaleString("es-CL", {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                            })
                          : "-"}
                      </td>
                    )}
                    <td style={{ textAlign: "right", fontSize: ".9rem", color: "#1b5e20" }}>
                      {formatCurrency(totalLocal)}
                    </td>
                  </tr>
                );
              })}
              <tr style={{ backgroundColor: "#e3f2fd", fontWeight: "bold" }}>
                <td colSpan={pais === "Perú" ? 7 : 7} />
                <td style={{ textAlign: "right", fontSize: "1rem", color: "#1b5e20" }}>
                  {formatCurrency(ingresosHardwareTotal || 0)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className={styles.modalActions}>
          <button className={styles.btnClose} onClick={onClose}>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};
